import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthContext";

export default function Settings() {
  const { t } = useTranslation();
  const { user } = useAuth();
  return (
    <div className="max-w-2xl" data-testid="settings-root">
      <div className="text-[11px] uppercase tracking-[0.28em] text-salnes-emerald mb-3">
        {t("nav.settings")}
      </div>
      <h1 className="font-serif text-4xl text-salnes-ink">
        {t("dashboard.settings_title")}
      </h1>
      <p className="mt-3 text-salnes-stone">{t("dashboard.settings_body")}</p>
      <div className="mt-8 rounded-2xl border hairline bg-white p-6 space-y-2">
        <div className="text-[11px] uppercase tracking-[0.22em] text-salnes-stone">
          {t("dashboard.account")}
        </div>
        <div className="font-serif text-lg text-salnes-ink">{user?.name}</div>
        <div className="text-sm text-salnes-stone">{user?.email}</div>
        <div className="text-xs text-salnes-stone">
          {t("dashboard.role")}: {t(`dashboard.role_${user?.role}`)}
        </div>
      </div>
    </div>
  );
}
